import { setExpiration } from './internal/expiration';

export function refreshBeastModeExpiration() {
  // Beast mode duration is 10 minutes, enforced on the backend.
  // We roughly keep track of this duration on the frontend.
  const duration = 1000 * 60 * 10;
  setExpiration(new Date().getTime() + duration);
}
